(function () {
    angular.module('bizPartEngage').directive('bizManagerGoals', bizManagerGoalsDirective);

    bizManagerGoalsDirective.$inject = ["bizCore"];

    function bizManagerGoalsDirective(bizCoreProvider) {
        var directive = {
            restrict: 'E',
            scope: {
            },
            templateUrl: bizCoreProvider.getView('bizMyGoalsDirective', 'FrontEnd/Modules/EngagementGoals/Views/Directives/managerGoals.html'),
            bindToController: true,
            controller: bizManagerGoalsController,
            controllerAs: 'vm'
        };

        bizManagerGoalsController.$inject = ["modules.goals.service", "$state", "$rootScope", "$mdToast", "$mdDialog", "bizCoreService", "core.unit.service", "$q"];

        return directive;

        function bizManagerGoalsController(engagementGoalsService, $state, $rootScope, $mdToast, $mdDialog, bizCoreService, unitService, $q) {
            var vm = this;
            vm.Statuses = [{ Id: 1, Text: 'Positiv' }, { Id: 2, Text: 'Neutral' }, { Id: 3, Text: 'Negativ' }];
            vm.ManagerGoals = [];

            vm.GetGoals = GetGoals;
            vm.Init = Init;
            vm.GotoToGoal = GotoToGoal;
            vm.OpenEdit = OpenEdit;

            function OpenEdit() {

                $q.all(
                    [
                        engagementGoalsService.GetGoals(false),
                        unitService.GetUsersInUnit($rootScope.LoggedInUser.Units[0].Id)
                    ]).then(LoadDataDone);

                function LoadDataDone(response) {
                    var managerGoals = response[0].data;
                    var usersInUnit = response[1].data;
                    
                    vm.ManagerGoals = [];
                    for (var i = 0; i < managerGoals.length; i++) {
                        if (managerGoals[i].ParentGoalId > 0) {
                            vm.ManagerGoals.push(managerGoals[i]);
                        }
                    }

                    vm.Users = [];
                    for (var i = 0; i < usersInUnit.length; i++) {
                        if (usersInUnit[i].Id != $rootScope.LoggedInUser.Id) {
                            vm.Users.push(usersInUnit[i]);
                        }
                    }

                    $mdDialog.show({
                        parent: angular.element(document.body),
                        templateUrl: siteRootPath + "FrontEnd/Modules/EngagementGoals/Views/Directives/mangagerGoalsEdit.html",
                        controller: EditDialogController,
                        controllerAs: "vm",
                        bindToController: true,
                        locals: {
                            Statuses: vm.Statuses,
                            GoalSettings: vm.GoalSettings,
                            ManagerGoals: vm.ManagerGoals,
                            Users: vm.Users
                        }
                    }).then(EditClose);
                }

                function EditClose(data) {
                    if (data) {
                        vm.GoalSettings = data;
                    }
                }

                EditDialogController.$inject = ["$mdDialog", "bizCoreService"];

                function EditDialogController($mdDialog, bizCoreService) {
                    var vm = this;

                    vm.Save = Save;
                    vm.Cancel = Cancel;
                    vm.AddGoal = AddGoal;
                    vm.Remove = Remove;
                    vm.GetStatusName = GetStatusName;
                    vm.UserSelected = UserSelected;

                    function UserSelected() {
                        vm.UserGoals = [];

                        if (vm.SelectedUser && vm.SelectedUser.Id > 0) {
                            engagementGoalsService.GetGoals(false, null, null, vm.SelectedUser.Id).then(DataCallback);

                            function DataCallback(response) {
                                var userGoals = BizPartCoreHelpers.getResponseValue(response, []);

                                for (var i = 0; i < userGoals.length; i++) {
                                    if (userGoals[i].ParentGoalId > 0) {
                                        vm.UserGoals.push(userGoals[i]);
                                    }
                                }
                            }
                        }
                    }

                    function Save() {
                        engagementGoalsService.SaveManagerGoals(vm.GoalSettings).then(SaveCallback);

                        function SaveCallback(response) {
                            var goalSettings = BizPartCoreHelpers.getResponseValue(response, []);
                            $mdDialog.hide(vm.GoalSettings);
                        }
                    }

                    function Cancel() {
                        $mdDialog.hide();
                    }

                    function AddGoal(isManagerGoal) {
                        var data = {
                            Id: isManagerGoal ? vm.SelectedGoal.Id : vm.SelectedUserGoal.Id,
                            Goal: isManagerGoal ? vm.SelectedGoal : vm.SelectedUserGoal,
                            Status: vm.SelectedStatus.Id,
                            IsManagerGoal: isManagerGoal ? true : false,
                            ShowIcon: isManagerGoal ? true : false,
                            Comment: ''
                        }

                        vm.GoalSettings.Goals.push(data);
                    }

                    function Remove(id, isManagerGoal) {
                        if (id > 0) {
                            for (var i = 0; i < vm.GoalSettings.Goals.length; i++) {
                                if (id == vm.GoalSettings.Goals[i].Id && (isManagerGoal && vm.GoalSettings.Goals[i].IsManagerGoal || isManagerGoal == false && vm.GoalSettings.Goals[i].IsManagerGoal == false)) {
                                    vm.GoalSettings.Goals.splice(i, 1);
                                    return;
                                }
                            }
                        }
                    }

                    function GetStatusName(id) {
                        if (id > 0) {
                            return vm.Statuses[id - 1].Text;
                        }

                        return '';
                    }
                }
            }

            function GotoToGoal(goal) {
                $state.go("base.modules.goals.onegoal", { id: goal.Id });
            }

            function GetGoals() {
                engagementGoalsService.GetManagerGoals().then(GetGoalsCallback);

                function GetGoalsCallback(response) {
                    vm.GoalSettings = BizPartCoreHelpers.getResponseValue(response, []);

                    if (!vm.GoalSettings.ManagerGoalOverrideHeader || vm.GoalSettings.ManagerGoalOverrideHeader.length == 0)
                        vm.GoalSettings.ManagerGoalOverrideHeader = 'Företagsmål'

                    if (!vm.GoalSettings.GoalOverrideHeader || vm.GoalSettings.GoalOverrideHeader.length == 0)
                        vm.GoalSettings.GoalOverrideHeader = 'Individuella mål'
                }
            }

            function Init() {
                if (vm.GoalSettings === undefined) {
                    vm.GetGoals();
                }
            }

            vm.$onInit = vm.Init;
        }
    }

}());